import PropTypes from 'prop-types';
import React from 'react';

const ExportPlayerItem = ({
  type,
  id,
  width,
  height,
  title,
  onClick,
  checked
}) => {
  return (
    <div className={`item ${type}`} onClick={onClick.bind(null, type)}>
      <input
        className="input-size"
        type="radio"
        name="export"
        id={id}
        checked={checked}
        readOnly
      />
      <label className="label-size" htmlFor={id}>
        <span className="item-title">{title}</span>
        <span className="info-size" htmlFor={id}>
          {width}
          px / {height}
          px
        </span>
      </label>
    </div>
  );
};

ExportPlayerItem.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ExportPlayerItem;
